import { useState } from "react";

export function ThreeDotsIcon({ onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ cursor: "pointer" }}
      onClick={onClick}
      id="three-dots-icon"
    >
      <path
        d="M4.49414 3.14746C4.46873 3.49108 4.35544 3.82345 4.16309 4.11133C3.94338 4.44012 3.63094 4.69628 3.26562 4.84766C2.90017 4.99903 2.49734 5.03908 2.10938 4.96191C1.72155 4.8847 1.36555 4.69368 1.08594 4.41406C0.80632 4.13444 0.615303 3.77845 0.538086 3.39062C0.460915 3.00266 0.500968 2.59983 0.652344 2.23438C0.803723 1.86906 1.05988 1.55662 1.38867 1.33691C1.71757 1.11715 2.10444 1 2.5 1H2.50098L2.69824 1.00977C3.15572 1.05567 3.58611 1.25798 3.91406 1.58594C4.2888 1.96068 4.49929 2.46907 4.5 2.99902V3L4.49414 3.14746ZM12.4941 3.14746C12.4687 3.49108 12.3554 3.82345 12.1631 4.11133C11.9434 4.44012 11.6309 4.69628 11.2656 4.84766C10.9002 4.99903 10.4973 5.03908 10.1094 4.96191C9.72155 4.8847 9.36555 4.69368 9.08594 4.41406C8.80632 4.13444 8.6153 3.77845 8.53809 3.39062C8.46092 3.00266 8.50097 2.59983 8.65234 2.23438C8.80372 1.86906 9.05988 1.55662 9.38867 1.33691C9.71757 1.11715 10.1044 1 10.5 1H10.501L10.6982 1.00977C11.1557 1.05567 11.5861 1.25798 11.9141 1.58594C12.2888 1.96068 12.4993 2.46907 12.5 2.99902V3L12.4941 3.14746ZM20.5 3C20.5 3.39556 20.3828 3.78243 20.1631 4.11133C19.9434 4.44012 19.6309 4.69628 19.2656 4.84766C18.9002 4.99903 18.4973 5.03908 18.1094 4.96191C17.7216 4.8847 17.3656 4.69368 17.0859 4.41406C16.8063 4.13445 16.6153 3.77845 16.5381 3.39062C16.4609 3.00266 16.501 2.59983 16.6523 2.23438C16.8037 1.86906 17.0599 1.55662 17.3887 1.33691C17.7176 1.11715 18.1044 1 18.5 1H18.501L18.6982 1.00977C19.1557 1.05567 19.5861 1.25798 19.9141 1.58594C20.2888 1.96068 20.4993 2.46907 20.5 2.99902V3Z"
        fill={hovered ? "#292b31ff" : "#676C7E"}
        stroke={hovered ? "#292b31ff" : "#676C7E"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
